import Information16 from '@carbon/icons-react/es/information/16';
import { Tooltip, Typography } from 'antd';
import React from 'react';
import { components } from 'react-select';
import styled from 'styled-components';
import { PlaceholderSelectTitle } from 'components/organisms/placeholders/select-group-title';
import { AssigneeOptionHeader } from './assignee-option-header';

const GroupTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
`;
const GroupTitleText = styled(Typography.Text).attrs({ ellipsis: true })`
  color: var(--gray-50);
`;
const GroupTitle = ({ id, label, count, description }) => {
  return (
    <GroupTitleWrapper>
      <GroupTitleText>
        {label} {id === 'assignees' ? `(${count})` : null}
      </GroupTitleText>
      {description != null ? (
        <Tooltip title={description}>
          <Information16 />
        </Tooltip>
      ) : null}
    </GroupTitleWrapper>
  );
};

export const GroupHeading = (props): JSX.Element => {
  const {
    data,
    label,
    onPlaceholderCreateClick,
    hidePlaceholderCreate,
    clearSelection,
    groupHeadingComponent: GroupHeadingComponent = components.GroupHeading,
  } = props;

  return (
    <GroupHeadingComponent {...props}>
      {data?.id === 'teams' ? (
        <PlaceholderSelectTitle
          onClick={onPlaceholderCreateClick}
          hideCreate={hidePlaceholderCreate}
        />
      ) : data?.id === 'assignees' ? (
        <AssigneeOptionHeader
          count={data?.options?.length ?? 0}
          onClearAll={clearSelection}
        />
      ) : (
        <GroupTitle
          id={data?.id}
          label={label}
          count={data?.options?.length ?? 0}
          description={data?.description}
        />
      )}
    </GroupHeadingComponent>
  );
};
